module.exports = "/packs/images/icons/icon-video-player-play-fed3715df233e5fac8cbf9b255b18554.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icons/icon-video-player-play.svg
// module id = 1795
// module chunks = 0